import * as React from 'react';

const Lv24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#9D2235",
    d: "M3 13.242V16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2.758zM5 6a2 2 0 0 0-2 2v2.763h18V8a2 2 0 0 0-2-2z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 10.763h18v2.48H3" }));
Lv24.Size = 24;
Lv24.Title = "Lv";

export { Lv24 as default };
